/**
 * Calculate CSS transform styles for image cropping display
 * 
 * @param {Object} cropData - Crop data with x, y, width, height percentages
 * @returns {Object} CSS style object with transform properties
 */
export const getCroppedImageStyle = (cropData) => {
  if (!cropData) return {};
  
  const { x, y, width, height } = cropData;
  
  // Calculate a reasonable scale that doesn't go extreme
  const scaleFactor = Math.min(
    100 / Math.max(width, 20), // Don't let crops smaller than 20% cause extreme scaling
    3 // Cap maximum scale at 3x
  );
  
  // Calculate where to position the scaled image
  // We want the center of the crop area to be at the center of the preview
  const cropCenterX = x + width / 2;
  const cropCenterY = y + height / 2;
  
  // Since we're scaling from center, we need to translate to move crop center to preview center
  const translateX = (50 - cropCenterX);
  const translateY = (50 - cropCenterY);
  
  return {
    transform: `scale(${scaleFactor}) translate(${translateX}%, ${translateY}%)`,
    transformOrigin: 'center center'
  };
};

/**
 * Helper function to extract image URL from various image formats
 * 
 * @param {string|Object} imageUrl - Image URL as string or object with url property
 * @returns {string} The image URL as string
 */
export const getImageUrl = (imageUrl) => {
  return typeof imageUrl === 'string' ? imageUrl : imageUrl?.url;
}; 